import moment from "moment";

/**
 * Parsea las líneas de texto extraídas de un PDF de FANASA (RFC: FNA951220DA9).
 * Retorna un Map<descripcionLower, { lotes, cantidadLinea }>
 *
 * Estrategia:
 * 1. Extraer productos de la tabla: ancla en el código de barras (10-14 dígitos) + "H87/PZA"
 * 2. Extraer lotes de la sección "DETALLE DE CODIGOS, LOTES, CADUCIDADES Y PIEZAS":
 *    formato (CODIGO,LOTE,DD-MMM-YY,PIEZAS)
 * 3. Unir por CODIGO y mapear por descripción
 */
export function parsearLineasFanasa(allLines) {
  // Línea de tabla: CODIGO(10-14d) CANT DESC ... BUL LAB PRECIO PRECIO OFE% DESC% H87/PZA
  const PRODUCT_LINE = /^(\d{10,14})\s+(\d+)\s+(.*?)\s+\d+\s+[A-Z]{2,5}\s+[\d.]+\s+[\d.]+\s+[\d.]+\s+[\d.]+\s+H87\/PZA/i;
  // Lote entre paréntesis: (CODIGO,LOTE,DD-MMM-YY o DD-MMM-YYYY,PIEZAS)
  const LOTE_RE = /\((\d{10,14}),([^,]+),(\d{2}-[A-Z]{3}-\d{2,4}),(\d+)\)/gi;

  const codigoToInfo = new Map(); // codigo -> { descripcion, cantidadLinea }
  const codigoToLotes = new Map(); // codigo -> [{ numero, caducidad, cantidad }]

  for (const line of allLines) {
    const m = line.match(PRODUCT_LINE);
    if (!m) continue;
    const codigo = m[1];
    const cantidad = parseInt(m[2], 10);
    const descRaw = m[3].trim();
    codigoToInfo.set(codigo, { descripcion: descRaw, cantidadLinea: cantidad });
  }

  const fullText = allLines.join('\n');
  let lotMatch;
  LOTE_RE.lastIndex = 0;
  while ((lotMatch = LOTE_RE.exec(fullText)) !== null) {
    const codigo = lotMatch[1];
    const lote = lotMatch[2].trim();
    const caducidad = moment(lotMatch[3], ['DD-MMM-YY', 'DD-MMM-YYYY']);
    const piezas = parseInt(lotMatch[4], 10);

    if (!codigoToLotes.has(codigo)) codigoToLotes.set(codigo, []);
    const lotes = codigoToLotes.get(codigo);
    const dup = lotes.find(l => l.numero === lote);
    if (dup) {
      dup.cantidad = (Number(dup.cantidad) || 0) + piezas;
    } else {
      lotes.push({ numero: lote, caducidad, cantidad: piezas });
    }
  }

  const productsByDesc = new Map();

  for (const [codigo, info] of codigoToInfo) {
    const lotes = codigoToLotes.get(codigo) || [];
    const entry = { lotes: [...lotes], cantidadLinea: lotes.length === 0 ? info.cantidadLinea : null };

    // Registrar con la descripción completa (ej. "51172107/ENCONTROPINA...")
    const keyFull = info.descripcion.toLowerCase().trim();
    productsByDesc.set(keyFull, entry);

    // Registrar también sin el prefijo numérico de clave (ej. "ENCONTROPINA...")
    const slashIdx = info.descripcion.indexOf('/');
    if (slashIdx > 0 && /^\d+$/.test(info.descripcion.slice(0, slashIdx))) {
      const keyShort = info.descripcion.slice(slashIdx + 1).toLowerCase().trim();
      if (keyShort && !productsByDesc.has(keyShort)) {
        productsByDesc.set(keyShort, entry);
      }
    }
  }

  return productsByDesc;
}
